/**
* Specials Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Specials Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'specials-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.specials-slider__splide' ).each( function( key, component ) {
        new Splide( component, {
          type: 'loop',
          gap: '2rem',
          perPage: 3,
          perMove: 1,
          pagination: false,
          speed: 800,
          breakpoints: {
            1025: {
              perPage: 2,
            },
            769: {
              perPage: 2,
            },
            640: {
              perPage: 1,
            },
          },
        } ).mount( {} );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'specials-slider', COMPONENT );
} )( app );
